var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_vm.getItems),function(item,itemIndex){return [_vm._t("item",null,{"item":item,"itemIndex":itemIndex})]}),_vm._v(" "),(!!_vm.$scopedSlots['append-after-last-item'])?_c('div',{staticClass:"col-12 row"},[_vm._t("append-after-last-item")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }